<template>
  <div class="left-side-container">
    <div class="left-side-container-section">
      <input type="radio" class="clickable" id="show-account-select" value="account" v-model="showReferencesMode">
      <label class="notification-filter-label bold">Show references for account</label>
      <transition name="slide">
        <v-select
            v-if="showReferencesMode === 'account'"
            :options="accountList"
            :value="selectedAccount"
            :clearable="false"
            class="v-select-styling"
            label="name"
            placeholder="Select Account"
            @search="onAccountSearch"
            @input="accountSelected"
        >
          <template slot="no-options">
            Type name or space to find accounts
          </template>
        </v-select>
      </transition>
    </div>
    <div class="left-side-container-section gray-border-bottom" v-if="this.isInternalAdminUserRole">
        <input type="radio" class="clickable" id="show-my-assigned" value="assigned" v-model="showReferencesMode">
        <label class="notification-filter-label bold" for="show-my-assigned">References for my assigned accounts</label>
    </div>
    <div v-if="showResetFilters" class="bg-white left-side-container-footer">
      <div class="notification-filter-container-left-section-input">
        <div class="">
          <a href="#" @click="resetFilter">Reset all filters</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {debounce} from "lodash";
import axios from "axios";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

export default {
  name: "AccountReferencesLeftPanel",
  computed: {
    ...mapState("UserDataStore", [
      "accountList",
    ]),
    ...mapGetters('AuthStore', {
      "isInternalAdminUserRole": "isAdminUser"
    }),
    ...mapState('AuthStore', {
      sessionUser: 'user',
      sessionAccount: 'account',
    }),
    ...mapState('AccountReferencesStore', [
      'references',
      'stats',
      'referenceDetailsModal',
      'editingReference',
      'selectedAccount',
      'showReferencesMode'
    ]),
    ...mapGetters('AuthStore', [
      'isAdminUser'
    ]),
    showResetFilters () {
      let ownAccountSelected = this.selectedAccount && this.selectedAccount.id !== this.sessionAccount.id;
      return ownAccountSelected || this.showReferencesMode !== 'account';
    },
    showReferencesMode: {
      get () {
        return this.$store.state.AccountReferencesStore.showReferencesMode;
      },
      set (value) {
        this.setShowReferencesMode(value);
        this.fetchReferences();
      }
    }
  },
  methods: {
    ...mapMutations("UserDataStore", [
      "setUser",
      "setAccount",
      "setUserList",
      "setAccountList",
    ]),
    ...mapMutations('AccountReferencesStore', [
      'setSelectedAccount',
      'setShowReferencesMode',
      'setCurrentPage'
    ]),
    ...mapActions('AccountReferencesStore', [
      'fetchReferences',

    ]),
    resetFilter () {
      this.setShowReferencesMode('account');
      this.setSelectedAccount(this.sessionAccount);
      this.fetchReferences();
    },
    onAccountSearch (search, loading) {
      if (search.length) {
        loading(true);
        this.searchAccounts(loading, search, this);
      }
    },
    accountSelected (value) {
      this.setSelectedAccount(value);
      this.setCurrentPage({
        url: undefined, //unused
        page: 1
      });
      this.fetchReferences();
    },
    searchAccounts: debounce((loading, search, vm) => {
      axios.get(`/accounts/all?search=${escape(search)}`).then((res) => {
        vm.setAccountList(res.data);
        loading(false);
      });
    }, 350),

  },

};
</script>

<style scoped>

</style>
